"use client";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <main className="mx-auto max-w-lg space-y-4 py-16 text-center">
      <h2 className="text-lg font-semibold">Something went wrong</h2>
      <p className="text-sm text-muted">Please try again. If the problem continues, contact support.</p>
      <button type="button" onClick={reset} className="btn-primary">
        Try again
      </button>
      {process.env.NODE_ENV === "development" && (
        <pre className="mt-4 overflow-auto rounded-lg bg-slate-100 p-3 text-left text-xs text-slate-700">
          {error.message}
        </pre>
      )}
    </main>
  );
}
